import { render } from "./ProductGalleryDesktop.vue?vue&type=template&id=9dc40b38&scoped=true"
import script from "./ProductGalleryDesktop.vue?vue&type=script&lang=js"
export * from "./ProductGalleryDesktop.vue?vue&type=script&lang=js"

import "./ProductGalleryDesktop.vue?vue&type=style&index=0&id=9dc40b38&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc40b38"]])

export default __exports__